import { create } from 'zustand'

export type ToastSeverity = 'success' | 'error' | 'warning' | 'info'

interface ToastItem {
  id: string
  message: string
  severity: ToastSeverity
}

interface ToastState {
  toasts: ToastItem[]
  addToast: (message: string, severity?: ToastSeverity) => void
  removeToast: (id: string) => void
  success: (message: string) => void
  error: (message: string) => void
  warning: (message: string) => void
  info: (message: string) => void
}

const MAX_TOASTS = 5
let toastCounter = 0

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  addToast: (message, severity = 'info') => {
    const id = `toast-${++toastCounter}`
    set((state) => {
      const next = [...state.toasts, { id, message, severity }]
      return { toasts: next.length > MAX_TOASTS ? next.slice(next.length - MAX_TOASTS) : next }
    })
  },
  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }))
  },
  success: (message) => {
    useToastStore.getState().addToast(message, 'success')
  },
  error: (message) => {
    useToastStore.getState().addToast(message, 'error')
  },
  warning: (message) => {
    useToastStore.getState().addToast(message, 'warning')
  },
  info: (message) => {
    useToastStore.getState().addToast(message, 'info')
  },
}))
